export default "data:image/jpeg;base64,ey8qIFBsYWNlaG9sZGVyIGZvciBiaW5hcnkgaW1hZ2UgY29udGVudCAqL30="